// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"562":"b88464b4","665":"5175b93c"}[chunkId] + ".chunk.css";
};